/**
 * CancelGoodbyeScreen — adaptateur primaire de la route `cancel-goodbye` (étape 5/5).
 *
 * Fil : ce que les étapes précédentes ont posé dans les paramètres de route → l'accusé. Aucun
 * service, aucun store (`CancelGoodbyeScreen.js` n'a pas de `connect`). La seule sortie est le
 * retour à l'espace parent, par `popToTop` — la croix et le bouton font la même chose, comme
 * dans le legacy.
 *
 * L'accusé de prise de rendez-vous (`outcome: "rp_appointment_booked"`) n'est pas porté : rien ne
 * l'émet.
 */
import React from "react"
import { useNavigation } from "@react-navigation/native"

import { CancelGoodbyePage } from "../../../../../../design-system"
import {
    toUICancelGoodbyeLead,
    toUICancelGoodbyeSummary,
} from "../../../../adapters/parent/SubscriptionCancel/subscriptionCancelAdapter"
import { type CancelFlowNavigation, type CancelFlowScreenProps } from "./cancelFlowNavigation"

export function CancelGoodbyeScreen(props: CancelFlowScreenProps) {
    const navigation = useNavigation<CancelFlowNavigation>()
    const routeParams = props.route?.params ?? {}
    const context = {
        paidCents: routeParams.paid_cents ?? 0,
        endOfMonth: routeParams.end_of_month ?? null,
        milestoneCancellation: routeParams.milestone_cancellation,
        resumeDate: routeParams.resume_date ?? null,
        parentEmail: routeParams.parent_email ?? null,
    }
    const backToSpace = () => navigation.popToTop()

    return (
        <CancelGoodbyePage
            lead={toUICancelGoodbyeLead(context)}
            summaryRows={toUICancelGoodbyeSummary(context)}
            onBackToSpace={backToSpace}
            onClose={backToSpace}
        />
    )
}

export default CancelGoodbyeScreen
